import axios from 'axios';
import { notification } from 'antd';
import { handlerError } from 'utils';

export const send2FA = async (sessionId, type) => {
    try {
        const req = {
            sessionId,
            type,
        };
        var ret = await axios.post(`/auth/2fa/send`, req);
        notification.success({
            message: 'Enviado com sucesso',
        });
        return ret.data;
    } catch (ex) {
        handlerError(ex);
        return ex.response.data;
    }
};

export const auth2FA = async (sessionId, code) => {
    let req = {
        sessionId,
        code,
    };
    return await axios.post(`/auth/2fa`, req);
};

export const authDeviceVerification = async (encryptedBody) => {
    return await axios.get(`/auth/device/`+ encryptedBody);
};
